import { createContext, useContext } from 'react';
export const defaultTracker = {
    setTarget: () => {
        // do nothing
    },
    trackPageView: () => {
        // do nothing
    },
};
export const TrackerContext = createContext(defaultTracker);
export const useTracker = () => {
    return useContext(TrackerContext);
};
TrackerContext.displayName = 'TribeTracker';
export const TribeTracker = TrackerContext.Provider;
//# sourceMappingURL=TrackerProvider.js.map